import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { Provider } from 'react-redux';
import { store } from './store/store';

const originalFetch = window.fetch;
window.fetch = async (url, config = {}) => {
    const token = localStorage.getItem('token');
    const headers = {
        ...config.headers,
    };

    if (token) {
        headers['Authorization'] = `${token}`;
    }

    // Handle URL normalization (Optional but helpful based on user's environment)
    let normalizedUrl = url;
    if (typeof url === 'string') {
        // If user uses 'Api' but backend expects 'api' (common issue in this project)
        // or if they missed the /api prefix
        // But we should be careful not to break external URLs
        const backendBase = "https://fasalshop.com";
        if (url.startsWith(backendBase) && !url.includes('/Api') && !url.includes('/api')) {
            normalizedUrl = url.replace(backendBase, `${backendBase}/Api`);
        }
    }

    return originalFetch(normalizedUrl, {
        ...config,
        headers,
    });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <RouterProvider router={router} />
    </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


